module.exports = __webpack_public_path__ + "img/three2Red.390d0b13.png";